// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1DioO","select":"Header_select__sT1yi","clinic":"Header_clinic__3PtHH"};